import { InjectionKey, Ref } from 'vue';
import { TripOptions } from '../services/trips/trip';
import { DisplayOptions } from './DisplayOptions';

export const TRIP_OPTION_KEY: InjectionKey<Ref<TripOptions | undefined>> =
  Symbol('TripOptions');

export const DISPLAY_OPTION_KEY: InjectionKey<Ref<DisplayOptions>> =
  Symbol('DisplayOptions');
